let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("9xVZ6")]).then(() => parcelRequire('kez1b'));